import request from '@/utils/request'


// 查询用户提现列表
export function listWithdraw(query) {
  return request({
    url: '/shop/withdraw/list',
    method: 'get',
    params: query
  })
}

// 查询用户提现分页
export function pageWithdraw(query) {
  return request({
    url: '/shop/withdraw/page',
    method: 'get',
    params: query
  })
}

// 查询用户提现详细
export function getWithdraw(data) {
  return request({
    url: '/shop/withdraw/detail',
    method: 'get',
    params: data
  })
}

// 查询店铺可提现金额
export function getAvailableMoney() {
  return request({
    url: '/shop/withdraw/availableMoney',
    method: 'get'
  })
}

// 新增用户提现
export function addWithdraw(data) {
  return request({
    url: '/shop/withdraw/add',
    method: 'post',
    data: data
  })
}

// 修改用户提现
export function updateWithdraw(data) {
  return request({
    url: '/shop/withdraw/edit',
    method: 'post',
    data: data
  })
}

// 删除用户提现
export function delWithdraw(data) {
  return request({
    url: '/shop/withdraw/delete',
    method: 'post',
    data: data
  })
}
